import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import styled from '@emotion/styled';
import ModalContainer from '@modals/ModalContainer';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

declare module '@stackflow/config' {
    interface Register {
        GiftCanceledModal: {};
    }
}

const GiftCanceledModal: ActivityComponentType<'GiftCanceledModal'> = () => {
    const { pop } = useFlow();
    const { t } = useTranslation('gift');
    return (
        <Modal>
            <ModalContainer>
                <Column fullWidth spacing={32}>
                    <Column fullWidth align='center'>
                        <Title size='3xl' fontWeight='bold'>
                            {t('giftCanceledModal.title')}
                        </Title>
                        <Text size='xl' align='center'>
                            {t('giftCanceledModal.description')}
                        </Text>
                    </Column>
                    <Button fullWidth onClick={pop}>
                        {t('giftCanceledModal.confirm')}
                    </Button>
                </Column>
            </ModalContainer>
        </Modal>
    );
};

const Title = styled(Text)`
    font-size: 24px;
    line-height: 36px;
`;

export default GiftCanceledModal;
